import type { Plugin, RouterContext } from '@atlassian/react-resource-router';

const CAPABILITY_HEADER_PLUGIN_ID = 'capability-header-plugin';

type SetCapability = (capability: string | null) => void;

const updateCapability = (context: RouterContext, setCapability: SetCapability): void => {
	setCapability(context.route.meta?.capability ?? null);
};

export const createCapabilityHeaderPlugin = (setCapability: SetCapability): Plugin => ({
	id: CAPABILITY_HEADER_PLUGIN_ID,
	beforeRouteLoad: ({ nextContext }) => updateCapability(nextContext, setCapability),
	routeLoad: ({ context }) => updateCapability(context, setCapability),
});
